// extracted by mini-css-extract-plugin
module.exports = {"lia-container":"CommunityMaintenancePlaceholder_lia-container__oZCWr"};